/**
 * Product Image Carousel
 * Auto-scrolling carousel with pause-on-interaction
 */

(function() {
  'use strict';

  // Configuration
  const AUTO_SCROLL_INTERVAL = 3000; // 3 seconds per image
  const PAUSE_DURATION = 15000; // 15 seconds pause on interaction

  class ProductCarousel {
    constructor(element) {
      this.carousel = element;
      this.slides = this.carousel.querySelectorAll('.carousel-slide');
      this.indicators = this.carousel.querySelectorAll('.indicator');
      this.prevBtn = this.carousel.querySelector('.carousel-prev');
      this.nextBtn = this.carousel.querySelector('.carousel-next');
      
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoScrollTimer = null;
      this.pauseTimer = null;
      this.isPaused = false;

      if (this.totalSlides <= 1) return; // No need for carousel with single image

      this.init();
    }

    init() {
      // Attach event listeners
      this.prevBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToPrev();
        this.pauseAutoScroll();
      });

      this.nextBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToNext();
        this.pauseAutoScroll();
      });

      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goToSlide(index);
          this.pauseAutoScroll();
        });
      });

      // Pause on hover (desktop)
      this.carousel.addEventListener('mouseenter', () => {
        this.pauseAutoScroll();
      });

      this.carousel.addEventListener('mouseleave', () => {
        if (!this.isPaused) {
          this.startAutoScroll();
        }
      });

      // Touch events for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      this.carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.carousel.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });

      // Start auto-scrolling
      this.startAutoScroll();

      console.log('✅ Carousel initialized with', this.totalSlides, 'slides');
    }

    handleSwipe(startX, endX) {
      const swipeThreshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next
          this.goToNext();
        } else {
          // Swipe right - prev
          this.goToPrev();
        }
        this.pauseAutoScroll();
      }
    }

    goToSlide(index) {
      // Remove active class from current
      this.slides[this.currentIndex].classList.remove('active');
      this.indicators[this.currentIndex]?.classList.remove('active');

      // Update index
      this.currentIndex = index;

      // Add active class to new
      this.slides[this.currentIndex].classList.add('active');
      this.indicators[this.currentIndex]?.classList.add('active');
    }

    goToNext() {
      const nextIndex = (this.currentIndex + 1) % this.totalSlides;
      this.goToSlide(nextIndex);
    }

    goToPrev() {
      const prevIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.goToSlide(prevIndex);
    }

    startAutoScroll() {
      this.stopAutoScroll();
      
      this.autoScrollTimer = setInterval(() => {
        this.goToNext();
      }, AUTO_SCROLL_INTERVAL);
    }

    stopAutoScroll() {
      if (this.autoScrollTimer) {
        clearInterval(this.autoScrollTimer);
        this.autoScrollTimer = null;
      }
    }

    pauseAutoScroll() {
      this.stopAutoScroll();
      this.isPaused = true;

      // Clear existing pause timer
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer);
      }

      // Resume after pause duration
      this.pauseTimer = setTimeout(() => {
        this.isPaused = false;
        this.startAutoScroll();
        console.log('📷 Auto-scroll resumed');
      }, PAUSE_DURATION);

      console.log('⏸️ Auto-scroll paused for 15 seconds');
    }

    destroy() {
      this.stopAutoScroll();
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer);
      }
    }
  }

  // Initialize all carousels on page
  function initCarousels() {
    const carousels = document.querySelectorAll('[data-product-carousel] .product-carousel');
    
    carousels.forEach(carousel => {
      new ProductCarousel(carousel);
    });

    console.log('✅ Initialized', carousels.length, 'product carousels');
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Re-initialize on dynamic content load (for AJAX cart, etc.)
  document.addEventListener('shopify:section:load', initCarousels);

})();
